// AUTO-GENERATED by scripts/gen-assets.mjs — DO NOT EDIT BY HAND.
// Add/rename vector assets in src/assets/vectors (kebab-case, subfolders allowed) and run `yarn assets:gen`.

import type { FunctionComponent, SVGProps } from 'react';

import BatteryCriticalVector from './battery/critical.svg?react';
import BatteryFullVector from './battery/full.svg?react';
import BatteryLowVector from './battery/low.svg?react';
import BatteryMiddleVector from './battery/middle.svg?react';
import ChevronDownVector from './chevron/down.svg?react';
import ChevronLeftVector from './chevron/left.svg?react';
import ChevronRightVector from './chevron/right.svg?react';
import ChevronUpVector from './chevron/up.svg?react';
import FiletypeCsvVector from './filetype/csv.svg?react';
import FiletypeExcelVector from './filetype/excel.svg?react';
import FiletypePdfVector from './filetype/pdf.svg?react';
import FiletypePemVector from './filetype/pem.svg?react';
import FiletypePfxVector from './filetype/pfx.svg?react';
import FlagDeVector from './flag/de.svg?react';
import FlagEnVector from './flag/en.svg?react';
import FlagNlVector from './flag/nl.svg?react';
import IconAlertCircleVector from './icon/alert-circle.svg?react';
import IconAlertTriangleVector from './icon/alert-triangle.svg?react';
import IconArrowsVector from './icon/arrows.svg?react';
import IconBarChartSquareVector from './icon/bar-chart-square.svg?react';
import IconBinVector from './icon/bin.svg?react';
import IconBookOpenVector from './icon/book-open.svg?react';
import IconBoxVector from './icon/box.svg?react';
import IconCalendarVector from './icon/calendar.svg?react';
import IconCheckVector from './icon/check.svg?react';
import IconClockVector from './icon/clock.svg?react';
import IconColumnsVector from './icon/columns.svg?react';
import IconCopyVector from './icon/copy.svg?react';
import IconCrossVector from './icon/cross.svg?react';
import IconDeviceVector from './icon/device.svg?react';
import IconDotsVerticalVector from './icon/dots-vertical.svg?react';
import IconDownloadVector from './icon/download.svg?react';
import IconEditVector from './icon/edit.svg?react';
import IconExportVector from './icon/export.svg?react';
import IconEyeVector from './icon/eye.svg?react';
import IconFileVector from './icon/file.svg?react';
import IconGlobeVector from './icon/globe.svg?react';
import IconHelpCircleVector from './icon/help-circle.svg?react';
import IconHomeLineVector from './icon/home-line.svg?react';
import IconImportVector from './icon/import.svg?react';
import IconInfoCircleVector from './icon/info-circle.svg?react';
import IconKeyVector from './icon/key.svg?react';
import IconLayoutVector from './icon/layout.svg?react';
import IconLinkVector from './icon/link.svg?react';
import IconLocationVector from './icon/location.svg?react';
import IconLockVector from './icon/lock.svg?react';
import IconLogoutVector from './icon/logout.svg?react';
import IconMailVector from './icon/mail.svg?react';
import IconNoPowerVector from './icon/no-power.svg?react';
import IconOfficeVector from './icon/office.svg?react';
import IconPhoneVector from './icon/phone.svg?react';
import IconPlaceholderVector from './icon/placeholder.svg?react';
import IconPlusVector from './icon/plus.svg?react';
import IconPrinterVector from './icon/printer.svg?react';
import IconRefreshVector from './icon/refresh.svg?react';
import IconRemoveVector from './icon/remove.svg?react';
import IconRfidVector from './icon/rfid.svg?react';
import IconSearchVector from './icon/search.svg?react';
import IconServerVector from './icon/server.svg?react';
import IconSettingsVector from './icon/settings.svg?react';
import IconSidePanelVector from './icon/side-panel.svg?react';
import IconSignalVector from './icon/signal.svg?react';
import IconSkopeiVector from './icon/skopei.svg?react';
import IconSlidersVector from './icon/sliders.svg?react';
import IconSupportVector from './icon/support.svg?react';
import IconSwapVector from './icon/swap.svg?react';
import IconSwitchVector from './icon/switch.svg?react';
import IconTemperatureVector from './icon/temperature.svg?react';
import IconTicketVector from './icon/ticket.svg?react';
import IconToolsVector from './icon/tools.svg?react';
import IconTruckVector from './icon/truck.svg?react';
import IconUnlinkVector from './icon/unlink.svg?react';
import IconUnlockVector from './icon/unlock.svg?react';
import IconUserVector from './icon/user.svg?react';
import IconUsersVector from './icon/users.svg?react';
import IconWebhookVector from './icon/webhook.svg?react';
import IconWrenchVector from './icon/wrench.svg?react';
import IllustrationDashboardVector from './illustration/dashboard.svg?react';
import IllustrationWebhooksVector from './illustration/webhooks.svg?react';
import LogoAppleVector from './logo/apple.svg?react';
import LogoConnectVector from './logo/connect.svg?react';
import LogoGoogleVector from './logo/google.svg?react';
import LogoMicrosoftVector from './logo/microsoft.svg?react';
import LogoSkopeiVector from './logo/skopei.svg?react';
import StatusDestructiveVector from './status/destructive.svg?react';
import StatusSuccessVector from './status/success.svg?react';
import StatusWarningVector from './status/warning.svg?react';

/** Maps a vector token to its SVG React component (currentColor-tintable). Consume via <VectorImage name="..." />. */
export const vectorRegistry = {
	'battery/critical': BatteryCriticalVector,
	'battery/full': BatteryFullVector,
	'battery/low': BatteryLowVector,
	'battery/middle': BatteryMiddleVector,
	'chevron/down': ChevronDownVector,
	'chevron/left': ChevronLeftVector,
	'chevron/right': ChevronRightVector,
	'chevron/up': ChevronUpVector,
	'filetype/csv': FiletypeCsvVector,
	'filetype/excel': FiletypeExcelVector,
	'filetype/pdf': FiletypePdfVector,
	'filetype/pem': FiletypePemVector,
	'filetype/pfx': FiletypePfxVector,
	'flag/de': FlagDeVector,
	'flag/en': FlagEnVector,
	'flag/nl': FlagNlVector,
	'icon/alert-circle': IconAlertCircleVector,
	'icon/alert-triangle': IconAlertTriangleVector,
	'icon/arrows': IconArrowsVector,
	'icon/bar-chart-square': IconBarChartSquareVector,
	'icon/bin': IconBinVector,
	'icon/book-open': IconBookOpenVector,
	'icon/box': IconBoxVector,
	'icon/calendar': IconCalendarVector,
	'icon/check': IconCheckVector,
	'icon/clock': IconClockVector,
	'icon/columns': IconColumnsVector,
	'icon/copy': IconCopyVector,
	'icon/cross': IconCrossVector,
	'icon/device': IconDeviceVector,
	'icon/dots-vertical': IconDotsVerticalVector,
	'icon/download': IconDownloadVector,
	'icon/edit': IconEditVector,
	'icon/export': IconExportVector,
	'icon/eye': IconEyeVector,
	'icon/file': IconFileVector,
	'icon/globe': IconGlobeVector,
	'icon/help-circle': IconHelpCircleVector,
	'icon/home-line': IconHomeLineVector,
	'icon/import': IconImportVector,
	'icon/info-circle': IconInfoCircleVector,
	'icon/key': IconKeyVector,
	'icon/layout': IconLayoutVector,
	'icon/link': IconLinkVector,
	'icon/location': IconLocationVector,
	'icon/lock': IconLockVector,
	'icon/logout': IconLogoutVector,
	'icon/mail': IconMailVector,
	'icon/no-power': IconNoPowerVector,
	'icon/office': IconOfficeVector,
	'icon/phone': IconPhoneVector,
	'icon/placeholder': IconPlaceholderVector,
	'icon/plus': IconPlusVector,
	'icon/printer': IconPrinterVector,
	'icon/refresh': IconRefreshVector,
	'icon/remove': IconRemoveVector,
	'icon/rfid': IconRfidVector,
	'icon/search': IconSearchVector,
	'icon/server': IconServerVector,
	'icon/settings': IconSettingsVector,
	'icon/side-panel': IconSidePanelVector,
	'icon/signal': IconSignalVector,
	'icon/skopei': IconSkopeiVector,
	'icon/sliders': IconSlidersVector,
	'icon/support': IconSupportVector,
	'icon/swap': IconSwapVector,
	'icon/switch': IconSwitchVector,
	'icon/temperature': IconTemperatureVector,
	'icon/ticket': IconTicketVector,
	'icon/tools': IconToolsVector,
	'icon/truck': IconTruckVector,
	'icon/unlink': IconUnlinkVector,
	'icon/unlock': IconUnlockVector,
	'icon/user': IconUserVector,
	'icon/users': IconUsersVector,
	'icon/webhook': IconWebhookVector,
	'icon/wrench': IconWrenchVector,
	'illustration/dashboard': IllustrationDashboardVector,
	'illustration/webhooks': IllustrationWebhooksVector,
	'logo/apple': LogoAppleVector,
	'logo/connect': LogoConnectVector,
	'logo/google': LogoGoogleVector,
	'logo/microsoft': LogoMicrosoftVector,
	'logo/skopei': LogoSkopeiVector,
	'status/destructive': StatusDestructiveVector,
	'status/success': StatusSuccessVector,
	'status/warning': StatusWarningVector,
} satisfies Record<string, FunctionComponent<SVGProps<SVGSVGElement>>>;

/** Union of every vector token, e.g. 'icon/plus' | 'other/webhooks'. */
export type VectorImageName = keyof typeof vectorRegistry;

/**
 * Maps a vector token to its raw bundled URL (authored colours, no currentColor)
 * for <VectorImage original />. Resolved via import.meta.glob so we don't repeat
 * an import line per icon — keys like './icon/mail.svg' become 'icon/mail'.
 */
export const vectorUrlRegistry = Object.fromEntries(
	Object.entries(
		import.meta.glob('./**/*.svg', { query: '?url', import: 'default', eager: true }),
	).map(([filePath, url]) => [filePath.replace(/^\.\//, '').replace(/\.svg$/, ''), url]),
) as Record<VectorImageName, string>;

export const vectorImageNames = Object.keys(vectorRegistry) as VectorImageName[];
